@if (availablePlans === 'showVerbose' ) {
  <section>
    <h2 class="secHeader">
      Available {{ yearSelected }} Plans for {{ countyInfo.zipCode || 'ZIP'}} in {{ countyInfo.county?.county || 'COUNTY'
      }} County.
      <span class="changeZipYear"><a class="verbose" href="javascript:void(0)" (click)="changeZip()">CHANGE
      AREA</a></span>
    </h2>
    <p>
      <span class="material-symbols-outlined warningIcon">warning</span> {{ marketingSubHeader||"To enroll in any of the plans, you must be
      eligible for Medicare and already enrolled in both Part A and Part B."}}
    </p>
  </section>
}


@if (availablePlans === 'showCompact' ) {
  <section class="zip-alert mat-typography mat-body mat-app-background ">
    <div class="zipbox">
      <div class="current-description" [ngClass]="{'no-visibility' : isAca.toString() === 'true'?true:false}">
        <div>{{ yearSelected }} <span> (Plan Year)</span></div>
      </div>
      @if (isMultiBrandASP()) {
        <div class="current-description">
          <div> {{ countyInfo.zipCode || 'ZIP'}}<span> (Zip Code) </span></div>
          <div> {{ countyInfo.county?.county || 'COUNTY' }}<span> (County) </span></div>
          <div> {{ countyInfo.county?.state || 'STATE' }}<span> (State)</span> </div>
        </div>
      }
      <div class="current-description" [ngClass]="{'no-visibility' : isIndividual.toString() === 'false' ? true:false}">
        <div>
          Effective Date: <a href="javascript:void(0)" (click)="changeZip()">{{displayEffectiveDate || 'MM/DD/YYYY'}}</a>
        </div>
        <div>
          Coverage for: <a href="javascript:void(0)" (click)="changeZip()">{{yearSelected || 'YEAR'}}</a>
        </div>
      </div>
      <div class="changeZipYear">
        <a href="javascript:void(0)" (click)="changeZip()">CHANGE AREA</a>
      </div>
    </div>
  </section>
}
